import { MouseEvent, useState } from "react";

type TUseModal = {
  toggleModal: () => void;
  handleStopPropagation: (event: React.SyntheticEvent) => void;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const useModal = (): TUseModal => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleModal = () => setIsOpen((p) => !p);

  const handleStopPropagation = (e: MouseEvent): void => {
    e.stopPropagation();
  };

  return { toggleModal, handleStopPropagation, isOpen, setIsOpen };
};

export default useModal;
